const api = {}

api.users = require('./users.js')
api.questions = require('./questions.js')
api.topics = require('./topics.js')
api.util = require('./util.js')

module.exports = api